exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".deal-info__info__EijjH+.deal-info__info__EijjH:before{content:\" / \"}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/shared/components/deal-info/src/shared/components/deal-info/deal-info.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/shared/components/deal-info/deal-info.styl"],"names":[],"mappings":"AAEI,uDACE,aAAA,CCDL","file":"deal-info.styl","sourcesContent":[".info\n  & + .info\n    &:before\n      content ' / '\n",".info + .info:before {\n  content: ' / ';\n}\n/*# sourceMappingURL=src/shared/components/deal-info/deal-info.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"info": "deal-info__info__EijjH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/deal-info/deal-info.styl
// module id = 1922
// module chunks = 66